import React from 'react';
import moment from 'moment';

const InformeReclamoTemplate = ({
    reclamo = {}
}) => {
    return (
        <div id='informeReclamoPrint' style={styles.container}>
            <div style={{
                ...styles.separateSection,
                ...styles.bloque,
                marginTop: '14px'
            }}>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Número de reclamo:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.numeroReclamo}
                    </span>
                </div>
            </div>
            <div style={{ ...styles.bloque, ...styles.separateSection }}>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Fecha Registro:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.fechaRegistro}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Paciente:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.paciente || '-'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>CAPA:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.capa ? 'SI' : 'NO'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Delegación:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.delegacion}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Financiador:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.financiador || '-'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Nro. de CAPA:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.idCapa || '-'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Área:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.area || '-'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Profesional/es:</strong>
                    <span style={styles.informeReclamoText}>
                        { (reclamo.correspondeProfesional) ? (reclamo.profesionales?.join(', ') || '-')  : '-'}
                    </span>
                </div>
                <div style={styles.columna33}>
                    <strong style={styles.paddingRight5}>Seguimiento FK:</strong>
                    <span style={styles.informeReclamoText}>
                        {reclamo.idSeguimientoFK || '-'}
                    </span>
                </div>
            </div>

            {!!reclamo.productos.length && <div style={{ ...styles.bloque, ...styles.separateSection }}>
                <div style={styles.columna100}>
                    <strong>Productos</strong>
                    <span style={styles.informeReclamoData}>

                        <div style={styles.tableContainer}>
                            <table style={styles.productTable} cellSpacing={0} cellPadding={0} >
                                <thead>
                                    <tr style={styles.tr}>
                                        <th style={{ ...styles.th, ...styles.paddingLeft5 }}>Tipo de producto</th>
                                        <th style={styles.th}>Nombre de producto</th>
                                        <th style={styles.th}>Lote</th>
                                        <th style={styles.th}>Número de remito</th>
                                        <th style={styles.th}>Fecha de vencimiento</th>
                                        <th style={{ ...styles.th, ...styles.paddingRight5, textAlign: 'right' }}>Cantidad</th>
                                    </tr>
                                </thead>
                                <tbody style={styles.tbody}>
                                    {reclamo.productos.map((producto, index) => (
                                        <tr style={styles.tr} key={index}>
                                            <td style={{ ...styles.td, ...styles.paddingLeft5 }}>{producto.tipo || '-'}</td>
                                            <td style={styles.td}>{producto.nombre || '-'}</td>
                                            <td style={styles.td}>{producto.lote || '-'}</td>
                                            <td style={styles.td}>{producto.numeroRemito || '-'}</td>
                                            <td style={styles.td}>{moment(producto.fechaVencimiento).format('DD/MM/YYYY') || '-'}</td>
                                            <td style={{ ...styles.td, ...styles.paddingRight5, textAlign: 'right' }}>{producto.cantidad || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </span>
                </div>
            </div>}
            <div style={{ ...styles.bloque, ...styles.separateSection }}>
                <div style={styles.columna100}>
                    <strong>Descripción del Reclamo</strong>
                    <span style={styles.informeReclamoData}>
                        {reclamo.descripcion || '-'}
                    </span>
                </div>
            </div>
            <div style={{ ...styles.bloque, ...styles.separateSection }}>
                <div style={styles.columna100}>
                    <strong>Acción inmediata</strong>
                    <span style={styles.informeReclamoData}>
                        {reclamo.accionInmediata || '-'}
                    </span>
                </div>
            </div>
            <div style={{ ...styles.bloque, ...styles.separateSection }}>
                <div style={styles.columna100}>
                    <strong>Resumen de investigación y descripción de cierre</strong>
                    <span style={styles.informeReclamoData}>
                        {reclamo.descripcionCierre}
                    </span>
                </div>
            </div>
            <div style={{ ...styles.bloque, marginBottom: '56px' }}>
                <div style={styles.columna100}>
                    <strong>Observaciones</strong>
                    <span style={styles.informeReclamoData}>
                        {reclamo.observacionFinal || '-'}
                    </span>
                </div>
            </div>
            <div style={{ ...styles.bloque, }}>
                <div style={styles.columna100}>
                    <strong>Firma</strong>
                    <br /><br />
                    <strong>{reclamo.firmante}</strong>
                    <span style={styles.informeReclamoData}>
                        {reclamo.tituloFirmante || '-'}
                    </span>
                    <div style={{ marginTop: '5px' }}>
                        <strong>Fecha y hora</strong>
                    </div>
                    <span style={styles.informeReclamoData}>
                        {/* reclamo */}
                        {reclamo.fechaFirma || '-'}
                    </span>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: 'Helvetica',
        paddingRight: '15px'
    },
    separateSection: {
        marginBottom: '28px',
    },
    bloque: {
        display: 'flex',
        flexWrap: 'wrap',
        color: '#212121',
        fontSize: '12px'
    },
    columna33: {
        flex: '0 0 33.33%',
    },
    columna100: {
        flex: '0 0 100%',
    },
    informeReclamoText: {
        fontSize: '10px'
    },
    paddingLeft5: {
        paddingLeft: '5px'
    },
    paddingRight5: {
        paddingRight: '5px'
    },
    tableContainer: {
        marginTop: '8px',
        width: '100%',
    },
    productTable: {
        overflow: 'hidden',
        margin: 0,
        padding: 0,
        width: '100%',
        borderCollapse: 'collapse'
    },
    tbody: {
    },
    th: {
        textAlign: 'left',
        fontSize: '9.5px',
        fontWeight: 'bold',
        background: '#636A73',
        color: '#ffffff',
        height: '19.3px'
    },
    tr: {
        fontSize: '9px'
    },
    informeReclamoData: {
        display: 'flex',
        fontSize: '11px',
    }
}

export default InformeReclamoTemplate;